import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { KlaviyoService } from '../../services/klaviyo.service';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';
import * as KlaviyoActions from '../actions/klaviyo.action';
import { getCustomer } from '../selectors';

@Injectable()
export class KlaviyoEffects {
  constructor(private actions$: Actions, private service: KlaviyoService, private store: Store) {}

  SubscribeBackInStock$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(KlaviyoActions.SubscribeBackInStock),
      switchMap(({ email, productId }) => {
        return this.service.subscribeBackInStock(email, productId).pipe(
          map(() => KlaviyoActions.SubscribeBackInStockSuccess({ email, productId })),
          catchError(error => of(KlaviyoActions.SubscribeBackInStockFail({ error })))
        );
      })
    );
  });

  GetKlaviyoSubscribedProductIds$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(KlaviyoActions.LoadKlaviyoSubscribedProductIds),
      withLatestFrom(this.store.select(getCustomer)),
      switchMap(([{}, customer]) => {
        return this.service.getKlaviyoSubscribedProducts(customer?.email || '').pipe(
          map(productIds => KlaviyoActions.LoadKlaviyoSubscribedProductIdsSuccess({ email: customer?.email || '', productIds })),
          catchError(error => of(KlaviyoActions.LoadKlaviyoSubscribedProductIdsFail({ error })))
        );
      })
    );
  });
}
